import { Capacitor } from '@capacitor/core';

/**
 * Returns true if running as a native iOS app (not web browser on iOS)
 */
export function isNativeIOS(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

/**
 * Returns true if running as a native Android app
 */
export function isNativeAndroid(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

/**
 * Returns true if running in any native app context
 */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Returns true if running in a web browser (not native)
 */
export function isWeb(): boolean {
  return !Capacitor.isNativePlatform();
}
